module.exports = __webpack_public_path__ + "static/media/divine_champion.d19852ae.png";